import { useEffect, useRef, useState } from 'react'
import isNil from 'lodash-es/isNil'

import { getAppointments } from '../../Appointment.api'
import { APPOINTMENTS_LOADING_STATE } from '../../Appointment.constants'
import {
  getAppointmentsRequestKey,
  getAppointmentsState,
} from '../../Appointment.utils'

export function useAppointments(params) {
  const [response, setResponse] = useState(APPOINTMENTS_LOADING_STATE)
  const [reloadKey, setReloadKey] = useState(0)

  const readIdRef = useRef(0)
  const reloadsRef = useRef([])

  const requestKey = getAppointmentsRequestKey(params)

  function settleReloads(data) {
    reloadsRef.current.splice(0).forEach(resolveReload => {
      resolveReload(data)
    })
  }

  async function readAppointments(readId) {
    return getAppointments({ params })
      .then(({ data }) => {
        if (readIdRef.current === readId) {
          setResponse({ data, isFailed: false, isLoading: false, requestKey })

          settleReloads(data)
        }
      })
      .catch(() => {
        if (readIdRef.current === readId) {
          setResponse({
            data: null,
            isFailed: true,
            isLoading: false,
            requestKey,
          })

          settleReloads(null)
        }
      })
  }

  // No params, no read: the list stays loading and a reload settles at once
  useEffect(() => {
    readIdRef.current += 1

    if (isNil(requestKey)) {
      settleReloads(null)
    } else {
      readAppointments(readIdRef.current)
    }
  }, [reloadKey, requestKey])

  async function handleReload() {
    readIdRef.current += 1

    return new Promise(resolve => {
      reloadsRef.current.push(resolve)

      setReloadKey(prevKey => prevKey + 1)
    })
  }

  return { ...getAppointmentsState({ requestKey, response }), handleReload }
}
